import router from '@/router'
import type { Config } from './tour'

export const CTAImportPopupConfig: Config = {
  onStart() {
    // Redirect to overview
    router.push('/').catch((error) => {
      if (error.name !== 'NavigationDuplicated') {
        throw error
      }
    })
  },
  steps: [
    // Open kebab menu
    {
      title: 'tutorial.cta.importPopup.openKebabMenu.title',
      text: 'tutorial.cta.importPopup.openKebabMenu.text',
      attachElement: '[data-test=kebab-menu]',
      nextOnClickElements: ['[data-test=kebab-menu] button'],
      attachPosition: 'top',
    },
    // Select import option
    {
      delay: 200, // Initial delay to make sure the dropdown is open
      title: 'tutorial.cta.importPopup.selectImport.title',
      text: 'tutorial.cta.importPopup.selectImport.text',
      attachElement: '[data-test=kebab-menu] [data-test=dropdown-wrapper]',
      preventFocusOutInElements: ['[data-test=kebab-menu]'],
      nextOnClickElements: [
        '[data-test=kebab-menu] [data-dropdown-item-id=import-entra]',
        '[data-test=kebab-menu] [data-dropdown-item-id=import-placetel]',
        '[data-test=kebab-menu] [data-dropdown-item-id=import-tcx]',
      ],
      highlightInternalElements: [
        '[data-test=kebab-menu] [data-dropdown-item-id=import-entra] button',
        '[data-test=kebab-menu] [data-dropdown-item-id=import-placetel] button',
        '[data-test=kebab-menu] [data-dropdown-item-id=import-tcx] button',
      ],
      preventClickInElements: [
        '[data-test=kebab-menu] [data-dropdown-item-id]:not([data-dropdown-item-id=import-entra],[data-dropdown-item-id=import-placetel],[data-dropdown-item-id=import-tcx])',
      ],
      attachPosition: 'top',
    },
  ],
}
